import { isFeatureEnabled } from '@/store/modules/feature-toggles.module'

const EMOJI_AVATAR_ATTR = 'showEmojiAvatar'

const _state = {
  isEnableAudienceAdmissionForm: false,
}

const _getters = {
  canUseToggleEmojiAvatar: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-toggle-emoji-avatar')
  },

  isEnableAudienceAdmissionForm(_, __, rootState, rootGetters) {
    // If the flag is turn on, fallback to the getter from participant module
    // because the new data flow are stored in different structure.
    if (rootGetters['participantModule/canUseCollectParticipantInfo']) {
      return rootGetters['participantModule/shouldCollectAudienceInfo']
    }
    const {
      audienceAdmission,
      // This state is managed by the audience admission form submission.
      // If the form has already been submitted, this flag will be true so we dont show the form anymore.
      // Any future extensions or updates regarding presentation admission form should make sure to be aware of this flag.
      disableFormJoinPresentation,
    } = rootState.presentation
    let enableAudienceAdmissionForm = false
    if (
      !disableFormJoinPresentation &&
      audienceAdmission &&
      audienceAdmission.isAudienceAdmission &&
      audienceAdmission.fields &&
      audienceAdmission.fields.length
    ) {
      audienceAdmission.fields.forEach((item) => {
        if (item.type === 'name' && !rootState.audienceName) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'email' && !rootState.audienceEmail) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'team' && !rootState.audienceTeam) {
          enableAudienceAdmissionForm = true
        }
      })
    }
    return enableAudienceAdmissionForm
  },
  isShownEmojiAvatar: (_, getters, rootState) => {
    const attrValue = rootState.presentationAttributeModule?.presentationAttribute?.[EMOJI_AVATAR_ATTR]
    // If undefined it should set to true because it's the current default value
    const showEmojiValue = attrValue ?? true
    return getters.canUseToggleEmojiAvatar
      ? showEmojiValue
      : true
  },
}

const actions = {

}

const mutations = {}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
